
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { NewsArticle } from "./types";
import { TableStatusBadge } from "./components/TableStatusBadge";
import { ArticleActions } from "./components/ArticleActions";
import { EmptyTableMessage } from "./components/EmptyTableMessage";

interface NewsTableProps {
  articles: NewsArticle[];
  onDelete: (id: number) => void;
  onTogglePublic: (id: number) => void;
}

export function NewsTable({ articles, onDelete, onTogglePublic }: NewsTableProps) {
  const formatDate = (dateString: string) => {
    return dateString;
  };

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Τίτλος</TableHead>
            <TableHead>Ημερομηνία</TableHead>
            <TableHead>Κατάσταση</TableHead>
            <TableHead className="text-right">Ενέργειες</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {articles.length === 0 ? (
            <EmptyTableMessage colSpan={4} message="Δεν υπάρχουν άρθρα" />
          ) : (
            articles.map((article) => (
              <TableRow key={article.id}>
                <TableCell className="font-medium">
                  <div className="max-w-[240px] truncate" title={article.title}>
                    {article.title}
                  </div>
                </TableCell>
                <TableCell>{formatDate(article.date)}</TableCell>
                <TableCell>
                  <TableStatusBadge isPublic={article.isPublic} />
                </TableCell>
                <TableCell>
                  <ArticleActions 
                    isPublic={article.isPublic}
                    onToggle={() => onTogglePublic(article.id)}
                    onDelete={() => onDelete(article.id)}
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
